export const jsmContextualRovoPromptSource = 'jsm-contextual-suggestions';
